var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomModebarOpenCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 25,
    viewBox: "0 0 56 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01855,
    width: 55,
    height: 23,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01855,
    width: 55,
    height: 23,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 7.51855L28 12.5186L33 17.5186M27 7.51855L22 12.5186L27 17.5186",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomModebarOpenCloseButton);
export default __webpack_public_path__ + "static/media/custom-modebar-open-close-button.b6b5596dedb0fcf8eb400b8c9c8e39ff.svg";
export { ForwardRef as ReactComponent };